import NavigationBar from "components/elements/navigation_bar";
import ButtonGradient from "components/elements/button_gradient";
import BackgroundImage from "assets/images/background_image.png";
import DialogDownloadResume from "components/views/dialog_download_resume";
import MenuOpenRoundedIcon from "@mui/icons-material/MenuOpenRounded";
import {
  Box,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  NAVIGATION_TOGGLE_DRAWER,
  RESUME_TOGGLE_DIALOG,
} from "utils/redux/action";
import { Fragment } from "react";
import SideBar from "components/elements/side_bar";

export default function LandingContainer() {
  const dispatcher = useDispatch();
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const resume = useSelector((state) => state.resumeReducer);
  const navigation = useSelector((state) => state.navigationReducer);

  return (
    <Fragment>
      <Box
        sx={{
          position: "relative",
          boxSizing: "border-box",
          width: "100vw",
          height: "100vh",
          overflowX:"hidden"
        }}
      >
        <Box
          sx={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundImage: `url(${BackgroundImage})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            opacity: 0.5,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: { xs: 20, md: 25 },
            right: { xs: 30, md: 50 },
            left: { xs: 30, md: 50 },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Link
            to={"/"}
            style={{
              textDecoration: "none",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "baseline",
              }}
            >
              <Typography
                variant="h1"
                sx={{
                  margin: 0,
                  padding: 0,
                  fontFamily: "Poppins",
                  fontWeight: "bold",
                  fontSize: { xs: 24, md: 28 },
                  color: "black",
                }}
              >
                Portofolio
              </Typography>
              <Typography
                variant="h1"
                sx={{
                  margin: 0,
                  padding: 0,
                  fontFamily: "Poppins",
                  fontWeight: "700",
                  fontSize: 40,
                  color: "#3672E9",
                }}
              >
                .
              </Typography>
            </Box>
          </Link>
          {matchUpMd ? (
            <Fragment>
              <NavigationBar />
              <ButtonGradient
                text={"Unduh CV"}
                onClick={() => dispatcher({ type: RESUME_TOGGLE_DIALOG })}
              />
            </Fragment>
          ) : (
            <Fragment>
              <IconButton
                sx={{ marginBottom: -1, marginRight: -1 }}
                onClick={() =>
                  dispatcher({ type: NAVIGATION_TOGGLE_DRAWER, drawer: true })
                }
              >
                <MenuOpenRoundedIcon sx={{ width: 36, height: 36 }} />
              </IconButton>
            </Fragment>
          )}
        </Box>
        <Box
          sx={{
            padding: { xs: "100px 30px 40px", md: "110px 40px 50px" },
            boxSizing: "border-box",
          }}
        >
          <Outlet />
        </Box>
      </Box>
      <SideBar
        open={navigation.drawer}
        handleClose={() =>
          dispatcher({ type: NAVIGATION_TOGGLE_DRAWER, drawer: false })
        }
      ></SideBar>
      <DialogDownloadResume
        open={resume.open}
        handleClose={() =>
          dispatcher({ type: RESUME_TOGGLE_DIALOG, drawer: false })
        }
      />
    </Fragment>
  );
}
